import type { IdentityManager } from './analytics-sdk.types';
import { ANONYMOUS_ID_STORAGE_KEY } from './analytics-sdk.types';

export const generateUUID = (): string =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const readAnonymousId = (): string | null => {
  try {
    return localStorage.getItem(ANONYMOUS_ID_STORAGE_KEY);
  } catch {
    return null;
  }
};

const writeAnonymousId = (id: string): void => {
  try {
    localStorage.setItem(ANONYMOUS_ID_STORAGE_KEY, id);
  } catch {
    // Silently ignore — localStorage may be unavailable or full.
  }
};

export const createIdentityManager = (): IdentityManager => {
  let anonymousId = readAnonymousId();

  if (!anonymousId) {
    anonymousId = generateUUID();
    writeAnonymousId(anonymousId);
  }

  let userId: string | undefined;

  return {
    setUserId: (id: string) => {
      userId = id;
    },

    clearUserId: () => {
      userId = undefined;
    },

    getAnonymousId: () => anonymousId as string,

    getIdentityContext: () => ({
      anonymousId: anonymousId as string,
      ...(userId !== undefined && { userId }),
    }),
  };
};
